// Login.js
import { useState } from "react";
import React from 'react';
import { signInWithGoogle, signInWithEmail, database } from "../firebase"; // Import the signInWithGoogle function and database service
function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailFormVisible, setIsEmailFormVisible] = useState(false);

    const encodeEmail = (email) => {
        // Replace "@" and "." with "_" to use as a key
        return email.replace(/[@.]/g, '_');
    };

    const handleLogin = async () => {
        try {
          const result = await signInWithGoogle();
          const user = result.user;
      
          if (user) {
            const userId = encodeEmail(user.email); // Encode email for use as user ID
            checkAndCreateUser(userId);
          }
        } catch (error) {
          console.error('Sign In Error:', error.message);
        }
      };
      
      const handleEmailLogin = async (e) => {
        e.preventDefault();
        try {
          const result = await signInWithEmail(email, password);
          const user = result.user;
    
          if (user) {
            const userId = encodeEmail(user.email); // Encode email for use as user ID
            checkAndCreateUser(userId);
          }
        } catch (error) {
          console.error('Email Login Error:', error.message);
        }
      };

      const checkAndCreateUser = async (userId) => {
        // Check if the user exists in the database
        const userSnapshot = await database.ref(`users/${userId}`).once('value');
      
        if (!userSnapshot.exists()) {
          // User does not exist, create with default values
          const randomNickname = generateRandomNickname(); // Generate a random nickname
      
          await database.ref(`users/${userId}`).set({
            balance: 5.00,
            tier: 'Basic',
            nickname: randomNickname // Set the random nickname
          });
      
          // Create the pronounscard folder with default values
          await database.ref(`users/${userId}/pronounscard`).set({
            pronouns: ["053"], // Default pronouns
            flags: ["000"],    // Default flags
            timezone: "Demo",  // Default timezone
            description: "Default description" // Default description
          });
        }
      };
      
      // Function to generate a random nickname
      const generateRandomNickname = () => {
        const adjectives = [ "Cool", "Bright", "Funny", "Silly", "Swift", "Amazing", "Gorgeous", 
          "Majestic", "Shimmering", "Ancient", "Vibrant", "Fierce", "Radiant", 
          "Serene", "Bold", "Mystic", "Rugged", "Glorious", "Enchanted", "Timeless", 
          "Noble", "Ethereal", "Invincible", "Proud", "Vast", "Eternal", "Sacred", 
          "Brave", "Loyal", "Radiant", "Luminous", "Fiery", "Gentle", "Mighty", 
          "Shadowed", "Fearless", "Intrepid", "Courageous", "Majestic", "Bold", 
          "Divine", "Peaceful", "Jovial", "Gracious", "Whimsical", "Wild", "Endless",
          "Noble", "Daring", "Classic", "Frosted", "Lush", "Seraphic", "Epic", "Gallant", 
          "Impressive", "Supreme", "Stunning", "Majestic", "Wild", "Boundless", "Vivid"];
        const nouns = ["Panda", "Tiger", "Eagle", "Shark", "Fox", "Bombay", "Zion", "Temasek", 
  "Hindustan", "Horizon", "Empire", "Kingdom", "Valley", "Dawn", "Majesty", 
  "Spirit", "Legacy", "Realm", "Dynasty", "Peak", "Summit", "Revolution", 
  "Glory", "Journey", "Fortress", "Land", "Triumph", "Heritage", "Lion", 
  "Dragon", "Temple", "Venture", "Quest", "Courage", "Phoenix", "Galaxy", 
  "Wings", "Inferno", "Thunder", "Storm", "Wolf", "Raven", "Vortex", "Mirage", 
  "Legion", "Titan", "Tide", "Canyon", "Vanguard", "Maverick", "Odyssey", 
  "Falcon", "Skyline", "Venture", "Chasm", "Valor", "Legend", "Vortex", 
  "Colossus", "Expanse", "Haven", "Warden", "Eclipse", "Ridge", "Bastion", 
  "Titan", "Seeker", "Stratus", "Ember", "Cinder", "Rogue", "Knight", "Sage", 
  "Beacon", "Inferno", "Nebula", "Warden", "Fortitude", "Seraph", "Shroud", 
  "Glory", "Spectre", "Titan", "Phantom", "Bastion", "Horizon", "Gale", "Dusk"];
        const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
        const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
        return `${randomAdjective}${randomNoun}${Math.floor(Math.random() * 10000)}`; // e.g., "CoolTiger23"
      };
      

    return (
        <><div className="login-container">
        <div className="login-box">
          <h2>EnbyBase Website Login</h2>
          <button onClick={handleLogin} className="google-button">
            Sign in with Google
          </button>
          <button onClick={() => setIsEmailFormVisible(!isEmailFormVisible)} className="meaa-button">
            Other Email
          </button>
          {isEmailFormVisible && (
  <form onSubmit={handleEmailLogin} className="loginf-email-login-form">
    <p>*If you have already got an address ends with @gmailemi.com, You can use this with one-time password.</p>
    <input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Enter your email"
      required
      className="loginf-email-input"
    />
    <input
      type="password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      placeholder="Enter your password"
      required
      className="loginf-password-input"
    />
    <button type="submit" className="loginf-submit-button">Log In</button>
  </form>
)}
<p className='ploginpbp'>For non-Gmail: Don't Have Accounts? Click<a href='/register' style={{textDecorationLine: 'none'}}> Here</a>.</p>
        </div>
      </div></>
    );
}

export default Login;